import { httpGet } from '../../../../common/util'
import { BaseUrl } from '../../../../config'

export const getGamesPage = page => {
    return httpGet({
        url: BaseUrl.replace('/api', '') + '/bff/game/list',
        data: {
            page,
            lang: window.__lang
        }
    })
}